import { createSelector } from 'reselect';
export { selectRemovePayTab } from 'reducers/selectors';
export const selectRecentInteractions = (store) => store.paymentsV2.recentInteractions;
export const selectCreditAndDebtAmounts = createSelector([
    (store) => store.paymentsV2.creditAndDebt?.credit,
    (store) => store.paymentsV2.creditAndDebt?.debt,
], (credit, debt) => ({ credit, debt }));
export const selectCreditAndDebtBreakdown = createSelector([
    (store) => store.paymentsV2.creditAndDebt?.creditBreakdown,
    (store) => store.paymentsV2.creditAndDebt?.debtBreakdown,
], (creditBreakdown, debtBreakdown) => ({ creditBreakdown, debtBreakdown }));
export const selectCreditAndDebtBreakdownFiltered = createSelector([
    selectCreditAndDebtBreakdown,
    (_, searchString) => searchString,
], ({ creditBreakdown, debtBreakdown }, searchString) => {
    if (searchString === '') {
        return { creditBreakdown, debtBreakdown };
    }
    const regExp = new RegExp(searchString, 'i');
    return {
        creditBreakdown: creditBreakdown?.filter((c) => 'firstName' in c.counterparty &&
            `${c.counterparty.firstName} ${c.counterparty.lastName}`.match(regExp)),
        debtBreakdown: debtBreakdown?.filter((c) => 'firstName' in c.counterparty &&
            `${c.counterparty.firstName} ${c.counterparty.lastName}`.match(regExp)),
    };
});
